import React from 'react';
import { Alert, Box, Stack } from '@mui/material';

import { PageHeader } from '../common';
import ModelLabPredictionTestingPanel from './ModelLabPredictionTestingPanel';

const ModelLabPredictionTestsPage: React.FC = () => (
  <Box>
    <PageHeader
      title="Prediction Tests"
      breadcrumbs={[
        { label: 'Model Lab', to: '/ai/model-lab' },
        { label: 'Prediction Tests' },
      ]}
    />

    <Stack spacing={2}>
      <Alert severity="info" variant="outlined">
        Test deployed Model Lab models against symbols and timeframes, then inspect replayed predictions, confidence, news/KG overlays, and feature-attribution timelines on chart history. The backend persists each run so you can reopen results and compare them later.
      </Alert>
      <ModelLabPredictionTestingPanel />
    </Stack>
  </Box>
);

export default ModelLabPredictionTestsPage;
